<template>
    <div
        class="home"
        :class="{ qiyangHome: qyBgSize }"
        :style="{ height: minHeight, backgroundSize: qyBgSize }"
    >
        <div
            v-if="$route.query.isHeader !== 'no'"
            :style="
                $route.params.id === ahLocId
                    ? {
                          'background-image': `url(${require('../../assets/images/home_header_bg-special.png')})`
                      }
                    : ''
            "
            class="header"
        >
            <div v-if="$route.params.id === ahLocId" class="back">
                <img src="@/assets/images/menu-box-adorn.png" />
                <a href="https://anhuaxian.nongjiao.com/" class="back--address"
                    >农村土地流转和金融服务平台</a
                >
            </div>
            <div class="title">{{ title }}</div>
            <div class="time">
                <div class="day">{{ time[0] }}</div>
                <div class="hour">{{ time[1] }}</div>
                <div class="week">{{ time[2] }}</div>
            </div>
        </div>
        <div class="body" :class="{ qiyangBody: qyBgSize }">
            <div class="left">
                <module
                    :moduleId="moduleList[0].moduleId"
                    :templateCode="moduleList[0].templateCode"
                    :moduleName="moduleList[0].moduleName"
                    :transferVariety="moduleList[0].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[1].moduleId"
                    :templateCode="moduleList[1].templateCode"
                    :moduleName="moduleList[1].moduleName"
                    :transferVariety="moduleList[1].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[2].moduleId"
                    :templateCode="moduleList[2].templateCode"
                    :moduleName="moduleList[2].moduleName"
                    :transferVariety="moduleList[2].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    v-if="qyLocId === $route.params.id"
                    :moduleId="moduleList[7].moduleId"
                    :templateCode="moduleList[7].templateCode"
                    :moduleName="moduleList[7].moduleName"
                    :transferVariety="moduleList[7].transferVariety"
                    :tradeSum="tradeSum"
                />
            </div>
            <div class="center">
                <map-block />
                <module
                    :moduleId="moduleList[3].moduleId"
                    :templateCode="moduleList[3].templateCode"
                    :moduleName="moduleList[3].moduleName"
                    :transferVariety="moduleList[3].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    v-if="qyLocId === $route.params.id"
                    :moduleId="moduleList[8].moduleId"
                    :templateCode="moduleList[8].templateCode"
                    :moduleName="moduleList[8].moduleName"
                    :transferVariety="moduleList[8].transferVariety"
                    :tradeSum="tradeSum"
                />
            </div>
            <div class="right">
                <module
                    :moduleId="moduleList[4].moduleId"
                    :templateCode="moduleList[4].templateCode"
                    :moduleName="moduleList[4].moduleName"
                    :transferVariety="moduleList[4].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[5].moduleId"
                    :templateCode="moduleList[5].templateCode"
                    :moduleName="moduleList[5].moduleName"
                    :transferVariety="moduleList[5].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[6].moduleId"
                    :templateCode="moduleList[6].templateCode"
                    :moduleName="moduleList[6].moduleName"
                    :transferVariety="moduleList[6].transferVariety"
                    :tradeSum="tradeSum"
                />
                <module
                    v-if="qyLocId === $route.params.id"
                    :moduleId="moduleList[9].moduleId"
                    :templateCode="moduleList[9].templateCode"
                    :moduleName="moduleList[9].moduleName"
                    :transferVariety="moduleList[9].transferVariety"
                    :tradeSum="tradeSum"
                />
            </div>
        </div>
    </div>
</template>

<script>
import * as screenAPI from '@/api/screen'
import MapBlock from './blocks/MapBlock'
import Module from './blocks/module'
import store from '@/utils/store'
import {
    getStaticTradeAmountSummary,
    getStaticLargeScreenAreaStatistics,
    getStaticLargeScreenItemStatistics
} from '@/utils/staticData'
import eventHub from '@/utils/eventHub'
import { STORE_AREA_INFO_KEY } from '@/constans/common'
import env from '@/config/env'

export default {
    data() {
        return {
            siteId: 0,
            title: '',
            minHeight: '',
            qyBgSize: '',
            time: ['', '', ''],
            ctype: 1,
            ahLocId: env.AHLOCID,
            qyLocId: env.QYLOCID,
            moduleList: [
                {
                    moduleId: 1
                },
                {
                    moduleId: 2
                },
                {
                    moduleId: 3
                },
                {
                    moduleId: 4
                },
                {
                    moduleId: 5
                },
                {
                    moduleId: 6
                },
                {
                    moduleId: 7
                }
            ],
            tradeSum: {
                ctype: '成交',
                money: {
                    tradeAmount_GQ: '0',
                    tradeAmount_JTJYZC: '0',
                    tradeAmount_JTZYXZC: '0',
                    tradeAmount_LQ: '0',
                    tradeAmount_TDJYQ: '0',
                    tradeAmount_ZJD: '0',
                    tradeAmount_JTJYZC_FW: '0',
                    tradeAmount_JTJYZC_JQSB: '0',
                    tradeAmount_JTJYZC_JZW: '0',
                    tradeAmount_JTJYZC_SP: '0',
                    tradeAmount_JTJYZC_YSGJ: '0',
                    tradeAmount_GYTDCBJYQ: '0',
                    tradeAmount_GYZC: '0'
                },
                area: {
                    lq: '0',
                    zj: '0',
                    gq: '0',
                    jtzyxzc: '0',
                    tdjyq: '0',
                    jtjyzc: '0',
                    gytdcbjyq: '0',
                    gyzc: '0'
                },
                count: {
                    expandVoList: [],
                    expandVoGyzcList: [],
                    lq: '0',
                    zj: '0',
                    gq: '0',
                    jtzyxzc: '0',
                    tdjyq: '0',
                    jtjyzc: '0',
                    gytdcbjyq: '0',
                    gyzc: '0'
                },
                priceRate: {
                    GQ: '',
                    JTJYZC: '',
                    JTZYXZC: '',
                    LQ: '',
                    TDJYQ: '',
                    ZJD: '',
                    GYTDCBJYQ: '',
                    GYZC: ''
                },
                mortgageSummary: {
                    amount: '',
                    number: ''
                }
            }
        }
    },
    components: {
        MapBlock,
        Module
    },
    watch: {
        $route: {
            handler: function(route) {
                const query = route.query
                if (!query.backId) {
                    sessionStorage.removeItem('list')
                }
            },
            immediate: true
        }
    },
    methods: {
        async getModuleList() {
            const params = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId: this.siteId
            }
            const moduleList = await screenAPI.queryBigScreenModuleSiteList(
                params
            )
            // 已有模板
            const allModuleId = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                12,
                10007,
                10008,
                10009,
                10010,
                10011
            ]
            this.moduleList = moduleList.data

            for (let k = 0; k < this.moduleList.length; k++) {
                for (let j = k + 1; j < this.moduleList.length; j++) {
                    if (this.moduleList[k].templateCode) {
                        // 循环遍历交易品种大类相同的数据
                        if (
                            this.moduleList[k].templateCode ===
                            this.moduleList[j].templateCode
                        ) {
                            // 判断是否存在交易品种大类模板
                            if (
                                !allModuleId.includes(
                                    this.moduleList[k].moduleId
                                )
                            ) {
                                this.moduleList[k].moduleId = this.moduleList[
                                    j
                                ].moduleId
                            }
                            // 判断是否存在交易品种大类模板
                            if (
                                !allModuleId.includes(
                                    this.moduleList[j].moduleId
                                )
                            ) {
                                this.moduleList[j].moduleId = this.moduleList[
                                    k
                                ].moduleId
                            }
                        } else {
                            if (
                                !allModuleId.includes(
                                    this.moduleList[k].moduleId
                                )
                            ) {
                                this.moduleList[k].moduleId = null
                                // 特殊处理 templateCode 为 1001 的交易品种，具体原因：与后台相关人员讨论
                                if (
                                    this.moduleList[k].moduleId === null &&
                                    this.moduleList[k].templateCode === '1001'
                                ) {
                                    this.moduleList[k].moduleId = 999
                                }
                            }
                        }
                    }
                }
            }

            // 因为要展示 7 个框框
            if (this.moduleList.length < 7) {
                const defectNum = 7 - this.moduleList.length
                for (let i = 0; i <= defectNum - 1; i++) {
                    this.moduleList.push({ moduleId: null })
                }
            }
        },
        async getSummary() {
            // 重置数据
            this.tradeSum = {
                ctype: '成交',
                money: {
                    tradeAmount_GQ: '0',
                    tradeAmount_JTJYZC: '0',
                    tradeAmount_JTZYXZC: '0',
                    tradeAmount_LQ: '0',
                    tradeAmount_TDJYQ: '0',
                    tradeAmount_ZJD: '0',
                    tradeAmount_JTJYZC_FW: '0',
                    tradeAmount_JTJYZC_JQSB: '0',
                    tradeAmount_JTJYZC_JZW: '0',
                    tradeAmount_JTJYZC_SP: '0',
                    tradeAmount_JTJYZC_YSGJ: '0',
                    tradeAmount_GYTDCBJYQ: '0',
                    tradeAmount_GYZC: '0'
                },
                area: {
                    lq: '0',
                    zjd: '0',
                    gq: '0',
                    jtzyxzc: '0',
                    tdjyq: '0',
                    jtjyzc: '0',
                    gytdcbjyq: '0',
                    gyzc: '0'
                },
                count: {
                    expandVoList: [],
                    expandVoGyzcList: [],
                    lq: '0',
                    zjd: '0',
                    gq: '0',
                    jtzyxzc: '0',
                    tdjyq: '0',
                    jtjyzc: '0',
                    gytdcbjyq: '0',
                    gyzc: '0'
                },
                priceRate: {
                    GQ: '',
                    JTJYZC: '',
                    JTZYXZC: '',
                    LQ: '',
                    TDJYQ: '',
                    ZJD: '',
                    GYTDCBJYQ: '',
                    GYZC: ''
                },
                mortgageSummary: {
                    amount: '',
                    number: ''
                }
            }
            // 2022-8-15 注释，偶尔导致图表不显示的问题
            // eventHub.$emit('tradeChange', this.tradeSum)

            const params = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId: this.siteId,
                locId: this.$getLocId(),
                summaryType: this.ctype //统计类型 1交易 2挂牌
            }
            const params2 = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId: this.siteId,
                areaCode: this.$getLocId(),
                ctype: this.ctype //获取数据类型 1成交 2挂牌
            }

            Promise.all([
                new Promise((resolve, reject) => {
                    screenAPI
                        .tradeAmountSummary(params)
                        .then((res) => {
                            if (!this.siteId) {
                                const data = getStaticTradeAmountSummary(
                                    params.summaryType
                                )
                                resolve(data)
                            } else {
                                resolve(res)
                            }
                        })
                        .catch((e) => {
                            reject(e)
                        })
                }),
                new Promise((resolve, reject) => {
                    screenAPI
                        .largeScreenAreaStatistics(params2)
                        .then((res) => {
                            if (!this.siteId) {
                                const data = getStaticLargeScreenAreaStatistics(
                                    params.summaryType
                                )
                                resolve(data)
                            } else {
                                resolve(res)
                            }
                        })
                        .catch((e) => {
                            reject(e)
                        })
                }),
                new Promise((resolve, reject) => {
                    screenAPI
                        .largeScreenItemStatistics(params2)
                        .then((res) => {
                            if (!this.siteId) {
                                const data = getStaticLargeScreenItemStatistics(
                                    params.summaryType
                                )
                                resolve(data)
                            } else {
                                resolve(res)
                            }
                        })
                        .catch((e) => {
                            reject(e)
                        })
                }),
                new Promise((resolve, reject) => {
                    screenAPI
                        .overPriceRate(params)
                        .then((res) => {
                            resolve(res)
                        })
                        .catch((e) => {
                            reject(e)
                        })
                }),
                new Promise((resolve, reject) => {
                    screenAPI
                        .mortgageSummary(params)
                        .then((res) => {
                            resolve(res)
                        })
                        .catch((e) => {
                            reject(e)
                        })
                })
            ]).then((res) => {
                this.tradeSum = {
                    ctype: this.ctype === 1 ? '成交' : '挂牌',
                    money: res[0].data || this.tradeSum.money,
                    area: res[1].data || this.tradeSum.area,
                    count: res[2].data || this.tradeSum.count,
                    priceRate: res[3].data || this.tradeSum.priceRate,
                    mortgageSummary:
                        res[4].data || this.tradeSum.mortgageSummary
                }
                eventHub.$emit('tradeChange', this.tradeSum)
            })
            // const money = await screenAPI.tradeAmountSummary(params) // 各交易品种成交金额统计   要加数据类型
            // const area = await screenAPI.largeScreenAreaStatistics(params2) // 各交易品种成交面积统计   要加数据类型
            // const count = await screenAPI.largeScreenItemStatistics(params2) // 各交易品种成交项目统计   要加数据类型
            // const priceRate = await screenAPI.overPriceRate(params) // 溢价率
            // const mortgageSummary = await screenAPI.mortgageSummary(params) // 金融贷款
            // this.tradeSum = {
            //   ctype: this.ctype === 1 ? '成交' : '挂牌',
            //   money: money.data || this.tradeSum.money,
            //   area: area.data || this.tradeSum.area,
            //   count: count.data || this.tradeSum.count,
            //   priceRate: priceRate.data || this.tradeSum.priceRate,
            //   mortgageSummary: mortgageSummary.data || this.tradeSum.mortgageSummary,
            // }
            // eventHub.$emit('tradeChange', this.tradeSum)
        },
        setTime() {
            const filling = (n) => (n >= 10 ? n : `0${n}`)
            const t = new Date()
            this.time = [
                `${t.getFullYear()}-${filling(t.getMonth() + 1)}-${filling(
                    t.getDate()
                )}`,
                `${filling(t.getHours())}:${filling(t.getMinutes())}`,
                [
                    '星期天',
                    '星期一',
                    '星期二',
                    '星期三',
                    '星期四',
                    '星期五',
                    '星期六'
                ][t.getDay()]
            ]
        }
    },
    beforeMount() {
        this.siteId =
            this.$route.params.id === 'zhongguo' ? 0 : this.$route.params.id

        const clientWidth = document.documentElement.clientWidth

        if (env.QYLOCID !== this.siteId) {
            this.minHeight = `${(1080 / 1920) * clientWidth}px`
            this.qyBgSize = ``
        } else {
            // 祁阳大屏样式特殊处理
            this.minHeight = `100vh`
            this.qyBgSize = `${clientWidth}px 100vh`

            // 祁阳大屏显示 10 个模块
            for (let i = 0; i <= 2; i++) {
                this.moduleList.push({ moduleId: i + 8 })
            }
        }
    },
    destroyed() {
        eventHub.$off('areaChange')
    },
    mounted() {
        /**
         * 存储当前地区 id
         * 并触发地区改变时间
         */
        store.setValue(STORE_AREA_INFO_KEY, {
            tuLiuLocId: this.siteId
        })
        sessionStorage.setItem('locId', this.siteId)
        // 监听当前站点区域id
        // eventHub.$on('areaCodeChange', (tid) => {
        //   store.setValue(STORE_AREA_INFO_KEY, {
        //     tuLiuLocId: this.siteId,
        //     tid,
        //   })
        //   eventHub.$emit('areaChange')
        // })

        this.getSummary()
        this.getModuleList()
        eventHub.$emit('areaChange')
        eventHub.$emit('tradeChange', this.tradeSum, 'init')

        /**
         * 监听标题改变事件
         */
        eventHub.$on('titleChange', (title) => {
            if (env.HNSLOCID === this.siteId) {
                document.title = this.title =
                    this.$route.name === 'haiken'
                        ? `${title}海垦交易大数据`
                        : `${title}农村产权交易大数据`
                sessionStorage.setItem('documentTitle', this.title)
            } else {
                document.title = this.title =
                    this.$route.name === 'haiken'
                        ? `${title}海垦交易大数据`
                        : `${title}农村产权交易大数据`
                sessionStorage.setItem('documentTitle', this.title)
            }
        })
        this.$eventHub.$on('areaChange', (data) => {
            this.ctype = data && data.ctype ? data.ctype : 1
            this.getSummary()
        })

        /**
         * 每 1 秒更新一次时间
         */
        this.setTime()
        setInterval(() => {
            this.setTime()
        }, 1000 * 1)
    }
}
</script>

<style lang="scss" scoped>
.table-info,
.solid-box,
.echarts-block {
    width: 620px !important;
}
.qiyangHome {
    justify-content: center;
    .qiyangBody {
        flex-grow: 0 !important;
    }
}
.home {
    font-family: PingFangSC-Regular, Microsoft YaHei, SimSun;
    display: flex;
    flex-direction: column;
    background-size: 1920px 1080px;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../../assets/images/bg.jpg');
    background-color: #04090f; // for ie10
    > .header {
        width: 100%;
        height: 76px;
        background-size: 1920px 100%;
        background-repeat: no-repeat;
        background-position: center top;
        background-image: url('../../assets/images/home_header_bg.png');
        position: relative;
        flex-shrink: 0;
        .back {
            position: absolute;
            width: 270px;
            margin: 8px 12px;
            text-align: right;
            z-index: 1;
            > img {
                width: 167px;
                position: relative;
                top: 3px;
            }
            &--address {
                width: 100%;
                height: 40px;
                font-size: 14px;
                background-size: 100% 100%;
                background-image: url('../../assets/images/menu-box.png');
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                color: #fff;
                text-decoration: none;
            }
        }
        > .title {
            font-family: SourceHanSansCN-Bold;
            line-height: 76px;
            text-align: center;
            font-size: 42px;
            color: #ffffff;
            letter-spacing: 1.15px;
            text-align: center;
            position: relative;
            top: -5px;
        }

        > .time {
            font-size: 18px;
            color: #67f0ff;
            height: 25px;
            top: 7.5px;
            line-height: 25px;
            position: absolute;
            right: 22px;
            display: flex;
            align-items: center;

            > .hour {
                margin-left: 16px;
            }

            > .week {
                margin-left: 32.5px;
            }
        }
    }

    > .body {
        padding: 13px 15px 11px 15px;
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        box-sizing: border-box;

        > .left,
        > .right,
        > .center {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
}
</style>
